import useAcl from '@/utils/hooks/user/useAcl';

import { aclFeatures } from '@/lib/acl/aclFeatures';

type SocialProfileNetwork = 'x' | 'threads' | 'youtube';

type UseSocialProfileAccessReturn = {
    hasAccess: boolean;
    requiresUpgrade: boolean;
    isLoading: boolean;
};

type UseSocialProfileAccessOptions = {
    network: SocialProfileNetwork;
};

/**
 * Unified hook to check social profile access using ACL permissions
 * Replaces individual hooks like useXAccess, useThreadsAccess, useYoutubeAccess
 */
export const useSocialProfileAccess = ({
    network
}: UseSocialProfileAccessOptions): UseSocialProfileAccessReturn => {
    const { hasAcl, isLoading } = useAcl();

    const getPermissionKey = (network: SocialProfileNetwork): string => {
        switch (network) {
            case 'x':
                return aclFeatures.social_profile.x.create;
            case 'threads':
                return aclFeatures.social_profile.threads.create;
            case 'youtube':
                return aclFeatures.social_profile.youtube.create;
            default:
                throw new Error(`Unsupported social profile network: ${network}`);
        }
    };

    const permissionKey = getPermissionKey(network);
    const hasAccess = hasAcl(permissionKey);

    return {
        hasAccess,
        requiresUpgrade: !hasAccess,
        isLoading
    };
};
